import { render } from "./TheServices.vue?vue&type=template&id=f1b950ea&scoped=true"
import script from "./TheServices.vue?vue&type=script&lang=js"
export * from "./TheServices.vue?vue&type=script&lang=js"

import "./TheServices.vue?vue&type=style&index=0&id=f1b950ea&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1b950ea"]])

export default __exports__